var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{staticClass:"w-25",attrs:{"placeholder":_vm.$t('active_project'),"clearable":false,"options":_vm.options,"value":_vm.activeProjectId},on:{"input":_vm.setActive}})
}
var staticRenderFns = []

export { render, staticRenderFns }